export default {
  // 禮品類型：1=實物禮品，2=虛擬禮品
  giftType: {
    1: '實物禮品',
    2: '虛擬禮品',
  },
  // 規格類型：1=單規格，2=多規格
  specType: {
    1: '單規格',
    2: '多規格',
  },
  // 上下架狀態：0=下架，1=上架
  publishStatus: {
    0: '已下架',
    1: '已上架',
  },
  // 訂單狀態：0=待處理，1=已兌換，2=已發貨，3=已完成，4=已取消，5=失敗
  orderStatus: {
    0: '待處理',
    1: '已兌換',
    2: '已發貨',
    3: '已完成',
    4: '已取消',
    5: '失敗',
  },
  // 發貨狀態：1=待發貨，2=已發貨，3=已完成
  shippingStatus: {
    1: '待發貨',
    2: '已發貨',
    3: '已完成',
  },
  // 賬號狀態：0=禁用，1=啟用
  accountStatus: {
    0: '已禁用',
    1: '進行中',
  },
  // 賬號類型：1=總賬號，2=子賬號
  accountType: {
    1: '總賬號',
    2: '子賬號',
  },
  // 加密協議
  encryption: {
    ssl: 'SSL',
    tls: 'TLS',
    none: 'None',
  },
  // 素材類型
  materialType: {
    image: '圖片',
    video: '視頻',
  },
  // 掃碼次數
  scanCount: {
    first: '首次',
    repeated: '重複掃碼',
  },
  // 默認模板開關
  isDefault: {
    on: '開啟',
    off: '關閉',
  },
};
